import axios from 'axios';
import message from 'src/utils/message';

//TODO:去环境变量拿
const API_BASE_URL = 'https://dolphinsound.net.cn/api';

let baseURL;
if (process.env.REACT_APP_LOCAL) {
  baseURL = "http://localhost:8080/api";
  console.log('当前接口地址', baseURL);
}
else {
  baseURL = process.env.NODE_ENV === 'production' ? API_BASE_URL : "/api";
}

console.log('Axios baseURL =', baseURL);

const instance = axios.create({
  baseURL,
  headers: { 'Authorization': 'e698c9f779e03cdbfdb1487c89ed289c01f92f83' },
});

instance.interceptors.response.use(function (response) {
  // console.log('即将发请求:Kyle wrote', response.url);
  if (!response.data)
    return Promise.reject("返回结构有误");

  if (response.data.code === undefined) {
    return Promise.resolve(response.data);
  }
  if (response.data.success)
    return Promise.resolve(response.data.data);
  else
    return Promise.reject(response.data.msg);
}, function (error) {
  // 对响应错误做点什么
  message.error("服务器错误");
  return Promise.reject(null);
});

export async function getHttp(api, params) {
  try {
    let data = await instance.get(api, { params }).catch(function (error) {
      return error.response;
    });
    return data;
  } catch (err) {
    return null;
  }
}
export async function postHttp(api, data) {
  try {
    let res = await instance.post(api, data);
    return res;
  } catch (err) {
    return null;
  }
}
export async function deleteHttp(api, data) {
  try {
    let res = await instance.delete(api, data);
    return res;
  } catch (err) {
    return null;
  }
}

export default instance;
